var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FieldItem",
    { attrs: { id: _vm.id, label: _vm.$t(_vm.fieldConfig.label) } },
    [
      _c("ElInputNumber", {
        staticClass: "search-preferences--number-input",
        attrs: { size: "small", precision: 0, min: 0 },
        on: {
          keypress: function ($event) {
            return _vm.isNumber($event)
          },
          change: _vm.syncChange,
        },
        model: {
          value: _vm.fieldValue,
          callback: function ($$v) {
            _vm.fieldValue = $$v
          },
          expression: "fieldValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }